import apiService from "./apiService";

const candidateService = {
    async search(searchParams) {
        try {
            return (await apiService.post(`contestant/search`, searchParams, true)).data;
        }
        catch {
            return [];
        }
    },
    async getInfo(id) {
        try {
            return (await apiService.get(`contestant/get-info/${id}`, {}, true)).data;
        }
        catch {
            return [];
        }
    },
    async saveContestant(contestant) {
        try {
            return (await apiService.post(`contestant/save/`, contestant, true)).data;
        }
        catch {
            return [];
        }
    },
    async deleteContestant(id) {
        try {
            return (await apiService.post(`contestant/delete/${id}`, {}, true)).data;
        }
        catch {
            return {success: false, message: "An error occured while processing the request."};
        }
    },
}

export default  candidateService;